// Number / decimal fields never take a minus sign (prices, quantities, fees, discounts…).
// One global guard instead of a check in every input: blocks the "-" key and strips "-" from
// pasted, dropped or mobile-keyboard input before v-model reads the value (capture phase).
const isNumericInput = (el) =>
  el instanceof HTMLInputElement &&
  (el.type === 'number' || ['decimal', 'numeric'].includes((el.getAttribute('inputmode') || '').toLowerCase()));

export function blockNegativeNumbers() {
  document.addEventListener('keydown', (e) => {
    if (e.key === '-' && isNumericInput(e.target)) e.preventDefault();
  }, true);

  document.addEventListener('input', (e) => {
    const el = e.target;
    if (isNumericInput(el) && el.value.includes('-')) el.value = el.value.replace(/-/g, '');
  }, true);
}
